function encrypt(message) {
  const source_characters = "abcdefghijklmnopqrstuvwxyz0123456789".split("");
  const target_characters = "g1xcou5bnklir28djv3sqwyhfm409z6tap7e".split("");
  const zip = (a, b) => a.map((k, i) => [k, b[i]]);
  const cipher = Object.fromEntries(zip(source_characters, target_characters));
  return message.replace(/[a-z0-9]/g, c => cipher[c]);
}

// Get app info based on URL
const url = window.location.href;
const params = new URLSearchParams(window.location.search);
const version = params.get("campaign") || "";
const cid = params.get("cid");

export default class Logger {
  constructor(pixelURL, surveyName) {
    this.pixelURL = pixelURL;
    this.survey_name = surveyName;
    this.session = "";
    this.user = "";

    // Check for CID value;
    if (cid) {
      window.localStorage.setItem("cid", cid);
    }

    // Get last session ID to resume from
    const session_id = window.localStorage.getItem("session_id");
    // Renew or create session
    if (session_id) {
      this.session = session_id;
      this.renewSession();
    } else {
      this.createSession();
    }
  }

  createSession() {
    this.session = crypto.randomUUID();

    // On the first playthrough, the user_id and session_id are the same
    if (this.user === "") {
      this.user = this.session;
    }
    this.log("sessions", {
      id: this.session,
      user_id: this.user,
      survey_name: this.survey_name,
      url,
      version,
      language: document.documentElement.lang,
      userAgent: navigator.userAgent,
    });

    window.localStorage.setItem("session_id", this.session);
    window.localStorage.setItem("user_id", this.user);
  }

  renewSession() {
    // Get the user id
    const user_id = window.localStorage.getItem("user_id");
    if (user_id) {
      this.user = user_id;
    } else {
      this.user = this.session;
    }

    // Log the renew event
    this.log("events", {
      event_type: "renew_session",
      location: location.href,
      target: "",
    });
  }

  log(collectionName, row) {
    const host = location.href;
    const payload = { ...row, session_id: this.session };

    if (/localhost|netlify/.test(host)) console.info(payload);
    const params = encrypt(new URLSearchParams(payload).toString());
    window
      .fetch(`/pixel?cn=${collectionName}&${params}`, {
        headers: {
          "Referrer-Policy": "unsafe-url",
        },
      })
      .catch(err => console.error("Logging failure:", err));
  }

  answer({
    module,
    question_type,
    question_name,
    answer_text,
    duration_in_seconds = null,
  }) {
    return this.log("answers", {
      module,
      question_type,
      question_name,
      answer_text,
      duration_in_seconds,
    });
  }

  event({ event_type, target, location = "" }) {
    return this.log("events", {
      event_type,
      target,
      location,
    });
  }
}
